import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { X, Loader2, Sparkles, MessageSquarePlus } from 'lucide-react';

export default function RefineMissionModal({ open, value, onChange, refining, onClose, onSubmit }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex items-end sm:items-center justify-center z-50 px-4 pt-4 pb-[max(env(safe-area-inset-bottom),1rem)]" onClick={onClose}>
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="bg-white rounded-3xl w-full max-w-md p-6 border-b-4 border-[#E5E5E5] max-h-[90dvh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        data-testid="refine-modal"
      >
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-2">
            <MessageSquarePlus size={24} strokeWidth={3} color="#1CB0F6" />
            <h3 className="text-xl font-extrabold">{t('c.dashboard.RefineMissionModal.tell_us_more')}</h3>
          </div>
          <button onClick={onClose} className="p-1" data-testid="close-refine-modal">
            <X size={24} strokeWidth={3} />
          </button>
        </div>
        <p className="text-sm text-[#AFAFAF] font-bold mb-4"> {t('c.dashboard.RefineMissionModal.add_any_detail_about_your_situation')} </p>
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="gm-input text-base"
          rows={5}
          maxLength={800}
          placeholder={t('c.dashboard.RefineMissionModal.e_g_i_work_7am_9pm')}
          data-testid="refine-details-input"
        />
        <p className="text-right text-xs text-[#AFAFAF] font-extrabold mt-1">{value.length}/800</p>
        <button
          onClick={onSubmit}
          disabled={refining || value.trim().length < 3}
          className="gm-btn gm-btn-primary w-full text-lg py-3 mt-3"
          data-testid="submit-refine"
        >
          {refining ? (
            <><Loader2 size={20} strokeWidth={3} className="animate-spin" /> {t('c.dashboard.RefineMissionModal.re_analysing')}</>
          ) : (
            <><Sparkles size={20} strokeWidth={3} /> {t('c.dashboard.RefineMissionModal.re_analyse_mission')}</>
          )}
        </button>
      </motion.div>
    </div>
  );
}
